import React, { Component } from "react";
import { translate } from "react-polyglot";
import { showLinkStatus, limits, roles as availableRoles } from '../../lib/constants';
import Link from '../Link';
import SvgIcon from '../SvgIcon';


const getInnerHTML = () => {
  let iframe = document.getElementsByTagName('iframe')[0];
  let innerDoc = iframe.contentDocument || iframe.contentWindow.document;
  let contentEl = innerDoc.getElementById('storyReader');
  return [innerDoc, contentEl];
}

class Suggestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMoreOrLess: showLinkStatus.more,
      storyBlocked: false,
      fullSuggestions: "",
      suggestionResolved: false
    }
  }

  onToggleLink = (value) => {
    if (this.state.showMoreOrLess === showLinkStatus.more) {
      let croppedText = value.substring(value.length, limits.charLimit)
      this.setState({ fullSuggestions: croppedText, showMoreOrLess: showLinkStatus.less })
    } else if (this.state.showMoreOrLess === showLinkStatus.less) {
      this.setState({ fullSuggestions: "", showMoreOrLess: showLinkStatus.more })
    }
  }

  isUserNotAuthor = () => {
    const { assets, userId } = this.props
    if (assets.authors) {
      let isUserAuthor = assets.authors.filter(author => author.id === userId);
      return isUserAuthor.length <= 0
    }
  }

  onHandleResolve = (suggestionId) => {
    const { updatePageContent, pages, t, currentPage, resolveSuggestionsWorkflow, addSlimNotification, init } = this.props;
    let innerDocument = getInnerHTML()[0];
    let contentEl = getInnerHTML()[1];

    let page = pages.find(function (page) {
      return page.pagePostion === currentPage
    });

    innerDocument.querySelectorAll(".has_comments").forEach(el => {
      if (el.classList.contains(suggestionId)) {
        if (el.classList.length === 2) {
          el.removeAttribute("class");
        }
        else {
          el.classList.remove(suggestionId);
        }
      }
    })
    const pageContent = contentEl.getElementsByClassName("content")[0].innerHTML
    resolveSuggestionsWorkflow(suggestionId, pageContent).then(response => {
      if (response.ok) {
        addSlimNotification({
          type: 'success',
          content: t('Book.suggestion-resolve-success')
        })
        this.setState({ suggestionResolved: true })
      }
      else {
        addSlimNotification({
          type: 'danger',
          content: response.data.errorMessage
        })
      }
    })
    updatePageContent(innerDocument.getElementById('storyReader').parentElement.innerHTML, page.pageId)
    setTimeout(() => init(), 0);
  }

  onBlockUser = (userId) => {
    const { t, addSlimNotification } = this.props
    this.props.blockUserWorkflow(userId).then(response => {
      if (response.ok) {
        addSlimNotification({
          type: 'success',
          content: t('Book.user-block-success')
        })
        this.props.userBlockedById({ isUserBlocked: userId })
      }
      else {
        addSlimNotification({
          type: 'danger',
          content: response.data.errorMessage
        })
      }
    })
  }

  onBlockStory = (slug) => {
    const { t, addSlimNotification } = this.props
    this.props.blockStoryWorkflow(slug).then(response => {
      if (response.ok) {
        addSlimNotification({
          type: 'success',
          content: t('Book.story-block-success')
        })
        this.setState({ storyBlocked: true })
      }
      else {
        addSlimNotification({
          type: 'danger',
          content: response.data.errorMessage
        })
      }
    })
  }

  render() {
    let { suggestion, t, book, baseClassName, onEdit, isUserBlocked } = this.props;

    const isContentManager = this.props.userRoles && this.props.userRoles.includes(availableRoles.CONTENT_MANAGER)

    return (
      this.state.suggestionResolved
        ?
        null
        :
        <div className={`${baseClassName}__suggestions`} data-comment={suggestion.suggestionId}>
          <div className={`${baseClassName}__suggestions-wrapper`}>
            <div className={`${baseClassName}__suggestions-img-wrapper`}>
              <img
                className={`${baseClassName}__suggestions-img`}
                src={suggestion.suggestUserProfileImg}
                alt="profile_picture" />
            </div>
            <div className={`${baseClassName}__suggestions-content`}>
              <div className={`${baseClassName}__suggestions-content-title`}>
                {
                  !this.isUserNotAuthor()
                    ?
                    suggestion.suggestUserName.length < 15 ? suggestion.suggestUserName : suggestion.suggestUserName.slice(0, 14).concat("...")
                    :
                    suggestion.suggestUserName.length < 18 ? suggestion.suggestUserName : suggestion.suggestUserName.slice(0, 17).concat("...")
                }
              </div>
              <div className={`${baseClassName}__suggestions-content-time`} >{suggestion.suggestionDate.toLowerCase()}</div>
            </div>
            {
              !this.isUserNotAuthor()
                ?
                <div className={`${baseClassName}__suggestions-content-right-icon`}>
                  <Link onClick={() => this.onHandleResolve(suggestion.suggestionId)}><SvgIcon name="resolve" title={t('SvgTitle.resolve')} size="sm" /></Link></div>
                :
                null
            }
          </div>
          <div className={`${baseClassName}__suggestions-content-body`}>
            {
              suggestion.suggestion.length > limits.charLimit
                ?
                suggestion.suggestion.slice(0, limits.charLimit).concat(this.state.fullSuggestions)
                :
                suggestion.suggestion
            }
          </div>
          <div className={`${baseClassName}__suggestions-content-link`}>
            {
              suggestion.suggestion.length > limits.charLimit
                ?
                <Link onClick={() => this.onToggleLink(suggestion.suggestion)}>{t(`global.show-${this.state.showMoreOrLess}`)}</Link>
                :
                null
            }
          </div>
          {
            !this.isUserNotAuthor()
              ?
              <div className={`${baseClassName}__suggestions-content-icons`}>
                {/* <Link><SvgIcon name="say-thanks" size="m"/></Link> */}

                {
                  //checking if author is content manager we have to remove icon block user 
                  !this.isUserNotAuthor() === isContentManager
                    ?
                    null
                    :
                    (
                      suggestion.userSuggestionsBlocked || (isUserBlocked === suggestion.suggestUserId)
                        ?
                        <a title={t('SvgTitle.blocked-user')}>
                          <SvgIcon name="blocked-user" size="sm"/></a>
                        :
                        <Link onClick={() => this.onBlockUser(suggestion.suggestUserId)}>
                          <SvgIcon name="block-user" size="sm" title={t('SvgTitle.block-user')} /></Link>
                    )
                }
                  {
                    suggestion.storySuggestionsBlocked || this.state.storyBlocked
                      ?
                      <a title={t('SvgTitle.blocked-suggestions-for-story')}> <SvgIcon name="blocked-suggestions-for-story" size="sm" /></a>
                      :
                      <Link onClick={() => this.onBlockStory(book.slug)}>
                      <SvgIcon name="block-suggestions-for-story" size="sm" title={t('SvgTitle.block-suggestions-for-story')} /></Link>
                  }

                <Link onClick={() => onEdit()}><SvgIcon name="icon-translate" size="sm" title={t('SvgTitle.icon-translate')} /></Link>

              </div>
              :
              null
          }
        </div>
    )
  }
}

export default translate()(Suggestion);


// WEBPACK FOOTER //
// ./src/components/BookReader/Suggestion.jsx